var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons/faEllipsisH';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import Modal from '../Modal';
import { LoadingSpinner } from '../base';
import Table from '../Table/Table';
import ButtonLink from '../ButtonLink';
import { PermissionsWrapper } from '../PermissionsWrapper';
import { getCategories } from '../../containers/Root/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCategories } from '../../containers/Root/selectors';
export var CategoryModal = function (_a) {
    var _b;
    var open = _a.open, handleClose = _a.handleClose, handleGoBack = _a.handleGoBack, _c = _a.loading, loading = _c === void 0 ? false : _c, openEditModal = _a.openEditModal, deleteCategory = _a.deleteCategory, _d = _a.selectedOrganizationId, selectedOrganizationId = _d === void 0 ? null : _d;
    var Columns = [
        { accessor: 'label', Header: 'Name', textAlign: 'start' },
        {
            accessor: 'global',
            Header: 'Global',
        },
        {
            accessor: 'created_at',
            Header: 'Date Created',
        },
        {
            Header: '',
            accessor: 'action',
            filter: 'fuzzyText',
        },
    ];
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(getCategories(selectedOrganizationId));
    }, [dispatch, selectedOrganizationId]);
    var categories = (_b = useSelector(selectCategories)) !== null && _b !== void 0 ? _b : [];
    var statusIcon = function (checked) {
        return checked ? (_jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "rgba(0, 0, 0, 0.85)", size: "1x", icon: faCheck })) : (_jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "rgba(0, 0, 0, 0.65)", size: "1x", icon: faEllipsisH }));
    };
    var handleRowClick = function (action, category) {
        switch (action) {
            case 'create':
                openEditModal();
                break;
            case 'edit':
                openEditModal(categories.find(function (cat) { return cat.id === category.id; }));
                break;
            case 'delete':
                if (
                // eslint-disable-next-line no-alert
                window.confirm('Are you sure you want to delete the category?')) {
                    deleteCategory(category.id);
                }
                break;
            default:
        }
    };
    return (_jsx(Modal, __assign({ headerTitle: "Categories", open: open, onClose: function () {
            handleClose();
        }, headerContent: _jsxs(_Fragment, { children: [_jsx("div", __assign({ style: { width: '50%', float: 'left' } }, { children: _jsx("div", __assign({ style: { float: 'left', display: 'inline-block' } }, { children: _jsx(ButtonLink, __assign({ onClick: handleGoBack }, { children: "Back" })) })) })), _jsx("div", __assign({ style: { width: '50%', float: 'right' } }, { children: _jsx("div", __assign({ style: { float: 'right', display: 'inline-block' } }, { children: _jsx(PermissionsWrapper, __assign({ action: "create", target: "org:".concat(selectedOrganizationId, ":templatecategories") }, { children: _jsx(ButtonLink, __assign({ onClick: function () { return handleRowClick('create'); } }, { children: "Create" })) })) })) }))] }) }, { children: !loading ? (_jsx(Table, { onRowClick: function (item) { return handleRowClick('edit', item); }, columns: Columns, data: categories.map(function (cat) { return (__assign(__assign({}, cat), { key: cat.label, global: statusIcon(cat.global), action: (_jsx("div", __assign({ className: "flex flex-row" }, { children: _jsx(PermissionsWrapper, __assign({ action: "delete", target: cat.global
                            ? 'org:apt:templatecategories'
                            : "org:".concat(selectedOrganizationId, ":templatecategories") }, { children: _jsx(ButtonLink, __assign({ onClick: function () {
                                handleRowClick('delete', cat);
                            } }, { children: "Delete" })) })) }))) })); }) })) : (_jsx(LoadingSpinner, {})) })));
};
